import type { GiftConfig } from '../types/gift-config'

export const mockGiftConfig: GiftConfig = {
  id: 'mock-gift-1',
  title: 'Подбор подарка',
  steps: [
    {
      id: 'welcome-1',
      type: 'welcome',
      title: 'Подберем подарок для вашего близкого'
    },
    {
      id: 'recipient-info-1',
      type: 'recipient_info',
      title: 'Кому вы ищите подарок?',
      required: true,
      relationshipOptions: [
        { value: 'friend', label: 'Друг' },
        { value: 'relative', label: 'Родственник' },
        { value: 'colleague', label: 'Коллега' },
        { value: 'partner', label: 'Партнер' }
      ],
      ageOptions: [
        { value: '18-25', label: '18-25' },
        { value: '26-35', label: '26-35' },
        { value: '36-45', label: '36-45' },
        { value: '46+', label: '46+' }
      ]
    },
    {
      id: 'price-range-1',
      type: 'price_range',
      title: 'Какой ценовой диапазон вы рассматриваете?',
      required: true,
      currencyOptions: [
        { value: 'RUB', label: 'RUB' },
        { value: 'USD', label: 'USD' },
        { value: 'EUR', label: 'EUR' }
      ],
      priceRangesByCurrency: {
        RUB: [
          { value: 'up-to-1000', label: 'До 1000 ₽' },
          { value: '1000-3000', label: '1000-3000 ₽' },
          { value: '3000-5000', label: '3000-5000 ₽' },
          { value: '5000-10000', label: '5000-10000 ₽' },
          { value: '10000+', label: '10000+ ₽' }
        ],
        USD: [
          { value: 'up-to-50', label: 'До 50 $' },
          { value: '50-100', label: '50-100 $' },
          { value: '100-200', label: '100-200 $' },
          { value: '200-500', label: '200-500 $' },
          { value: '500+', label: '500+ $' }
        ],
        EUR: [
          { value: 'up-to-50', label: 'До 50 €' },
          { value: '50-100', label: '50-100 €' },
          { value: '100-200', label: '100-200 €' },
          { value: '200-500', label: '200-500 €' },
          { value: '500+', label: '500+ €' }
        ]
      }
    },
    {
      id: 'interests-1',
      type: 'interests',
      title: 'Что больше всего интересует?',
      subtitle: 'Можете выбрать несколько вариантов',
      required: false,
      interests: [
        { value: 'clothing', label: 'Одежда' },
        { value: 'shoes', label: 'Обувь' },
        { value: 'accessories', label: 'Аксессуары' },
        { value: 'cosmetics', label: 'Косметика' },
        { value: 'jewelry', label: 'Украшения' },
        { value: 'watches', label: 'Часы' },
        { value: 'bags', label: 'Сумки' }
      ]
    },
    {
      id: 'occasion-1',
      type: 'occasion',
      title: 'Для какого случая подарок?',
      subtitle: 'Можете выбрать несколько вариантов',
      required: true,
      occasions: [
        {
          value: 'birthday',
          label: 'День рождения',
          subOptions: [
            { value: 'child', label: 'Детский день рождения' },
            { value: 'adult', label: 'Взрослый день рождения' },
            { value: 'milestone', label: 'Юбилейный день рождения' }
          ]
        },
        { value: 'anniversary', label: 'Юбилей' },
        { value: 'wedding', label: 'Свадьба' },
        { value: 'new-year', label: 'Новый год' },
        {
          value: 'holiday',
          label: 'Праздник',
          subOptions: [
            { value: 'new-year', label: 'Новый год' },
            { value: 'march-8', label: '8 марта' },
            { value: 'february-23', label: '23 февраля' },
            { value: 'valentines', label: 'День святого Валентина' }
          ]
        }
      ]
    },
    {
      id: 'brand-selection-1',
      type: 'brand_selection',
      title: 'Стиль каких брендов ему нравится?',
      subtitle: 'Вы можете пропустить этот вопрос, если не знаете',
      required: false,
      brands: [
        { id: 1, name: 'Zara', logo: '/img/brands/zara-logo.png' },
        { id: 2, name: "H&M", logo: '/img/brands/hm-logo.png' },
        { id: 3, name: 'Uniqlo', logo: '/img/brands/uniqlo-logo.png' },
        { id: 4, name: 'Nike', logo: '/img/brands/nike-logo.png' },
        { id: 5, name: 'Adidas', logo: '/img/brands/adidas-logo.png' },
        { id: 6, name: "Levi's", logo: '/img/brands/levis-logo.png' },
        { id: 7, name: 'Gucci', logo: '/img/brands/gucci-logo.png' },
        { id: 8, name: 'Louis Vuitton', logo: '/img/brands/lv-logo.png' }
      ]
    },
    {
      id: 'style-likes-1',
      type: 'style_likes',
      title: 'Какие стили ему нравятся?',
      subtitle: "Поставьте '<3' каждому понравившемуся стилю",
      required: false,
      styles: [
        { id: '1', name: 'Классический', image: '/img/styles/classic.jpg' },
        { id: '2', name: 'Спорт', image: '/img/styles/sport.jpg' },
        { id: '3', name: 'Кэжуал', image: '/img/styles/casual.jpg' },
        { id: '4', name: 'Деловой', image: '/img/styles/business.jpg' },
        { id: '5', name: 'Романтический', image: '/img/styles/romantic.jpg' }
      ]
    },
    {
      id: 'completion-1',
      type: 'completion',
      title: 'Подборка готова!'
    }
  ]
}

